// extracted by mini-css-extract-plugin
export default {"termsAndCondContainer":"T&C_termsAndCondContainer__2bVTv","termsAndCond":"T&C_termsAndCond__cWWV4"};